module.exports = __webpack_public_path__ + "static/img/9.9d07909.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/9.png
// module id = K1s7
// module chunks = 0